import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ColumnExpandIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 16 16"
        className="Icon column-expand"
        {...props}
    >
            <path
                fill="#1B2536"
                fillOpacity={0.5}
                d="M7.646 3.146a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1-.708.708L8 4.207 5.854 6.354a.5.5 0 0 1-.638.057l-.07-.057a.5.5 0 0 1 0-.708l2.5-2.5zm0 9.708a.5.5 0 0 0 .708 0l2.5-2.5a.5.5 0 0 0-.708-.708L8 11.793 5.854 9.646a.5.5 0 0 0-.638-.057l-.07.057a.5.5 0 0 0 0 .708l2.5 2.5z"
            />
    </svg>
);
const Memo = memo(ColumnExpandIcon);
export default Memo;
